// extracted by mini-css-extract-plugin
export var adjacentSlide = "_j6-9";
export var arrowButtonContainer = "_j6-5";
export var arrowButtonIcon = "_j6-6";
export var carouselArrowButton = "_j6-2";
export var carouselElementContainer = "_j6-1";
export var currentSlide = "_j6-8";
export var left = "_j6-3";
export var otherSlide = "_j6-a";
export var productCarouselContainer = "_j6-0";
export var right = "_j6-4";
export var sliderOverflow = "_j6-7";